export default {
    hWarning: {
        backgroundColor: "#ef4848 !Important",
        fontSize: "12px"
    }
};